import {AuthenticationRepository} from "../../../repositories/AuthenticationRepository";

export class SendMagicLinkUseCase {
  constructor(private readonly repository: AuthenticationRepository) {}

  sendMagicLink(email: string) {
    return this.repository.sendMagicLink(email)
  }
}
